import { useEffect, useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import Services from '~/ui/components/common/Services';
import { homeServicesMock } from '~/ui/components/common/Services/servicesMock';
import EarnAndBurnSection from './sections/EarnAndBurnSection';
import HeroSection from './sections/HeroSection';
import GuestFavouritesSection from './sections/GuestFavouritesSection';
import BeddingSetSection from './sections/BeddingSetSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import BeddingSection from './sections/BeddingSection';
import BathSection from './sections/BathSection';
import BlogSection from './sections/BlogSection';
import { getYmal } from '@Hotels-at-Home/hah-fe-core/dist/store/ymal/thunks';
import { useDispatch } from '~/store/hooks';
import { useRouter } from 'next/router';
import { useShowError } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import LinenSection from './sections/LinenSection';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  const dispatch = useDispatch();
  const { locale } = useRouter();
  const showError = useShowError();

  useAnimate(animateRef);

  // fetch YMALS for HP

  const fetchYmal = async () => {
    const ymalResult = await dispatch(getYmal());

    if (getYmal.rejected.match(ymalResult)) {
      showError(ymalResult.payload.errorMessage);
    }
  };

  useEffect(() => {
    fetchYmal();
  }, [locale]);
  return (
    <div id="home" ref={animateRef}>
      <HeroSection />
      <GuestFavouritesSection />
      <BeddingSetSection />
      <BeddingSection />
      <LinenSection />
      <BathSection />
      <BlogSection />
      <EarnAndBurnSection />
      <Services items={homeServicesMock} mainSection />
    </div>
  );
};

export default Home;
